module.exports = __webpack_public_path__ + "img/favicon.61ecace3.png";